import { ModuleWithProviders } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";

import {FeaturesComponent} from "./features.component";
import {ProductFilterComponent} from "./product/product-filter/product-filter.component";
import {ProductsComponent} from "./product/products.component";
import {CartComponent} from "./cart/cart.component";
import {ProductDetailsComponent} from "./product/product-details/product-details.component";
import {ListingComponent} from "./product/listing/listing.component";
import {authGuard} from "../core/guards/auth.guard";
import {LoginComponent} from "./components/auth/login/login.component";
import {SignupComponent} from "./components/auth/signup/signup.component";
import { RegisterComponent } from "./components/auth/register/register.component";
import {OffersComponent} from "./components/offers/offers.component";
import {ReachUsComponent} from "./components/policy/reach-us/reach-us.component";
import {OrderStatusComponent} from "./components/order-status/order-status.component";
import {PolicyComponent} from "./components/policy/policy.component";
import {CancelOrderComponent} from "./components/cancel-order/cancel-order.component";
import {HomepageResolver} from "../homepage-resolver.service";

/**
 * Created by vikas on 09-01-2025.
 */
const router: Routes = [
  {
    path: '',
    component: FeaturesComponent,
    children: [
      { path: '', component: ProductsComponent, resolve: { banners: HomepageResolver } },
      { path: 'user', loadChildren: () => import('app/features/profile/profile.module').then(m => m.ProfileModule) , canActivate: [authGuard],},
      { path: 'search', component: ProductFilterComponent, data: { title: "Search" } },
      { path: 'cart', component: CartComponent, data: { title: "Cart" } },
      { path: 'product/:id', component: ProductDetailsComponent, data: { title: "Product Details" } },
      { path: 'products/:page', component: ListingComponent, data: { title: "Smart Dukaan" } },
      { path: 'login', component: LoginComponent, data: { title: "Smart Dukaan" } },
      { path: 'register', component: SignupComponent, data: { title: "Smart Dukaan" } },
      { path: 'auth', component: RegisterComponent, data: { title: "Smart Dukaan" } },
      { path: 'offer', component: OffersComponent, data: { title: "Smart Dukaan" } },
      { path: 'reach-us', component: ReachUsComponent, data: { title: "Smart Dukaan" } },
      { path: 'order-status/:pendingOrderId', component: OrderStatusComponent, data: { title: "Smart Dukaan" } },
      { path: 'cancel-order', component: CancelOrderComponent, data: { title: "Smart Dukaan" } },
      { path: ':policyType', component: PolicyComponent, data: { title: "Smart Dukaan" } },

    ]
  }
];


export const routing: ModuleWithProviders<any> = RouterModule.forChild(router);
